import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import budgeting from '../../assets/img/finance/anggaran.png';
import bookkeeping from '../../assets/img/bookkeeping/jurnal_bank.png';
import pengumuman from '../../assets/img/kurikulum/pengumuman.png';
import jadwal from '../../assets/img/kurikulum/jadwal.png';
import matapelajaran from '../../assets/img/kurikulum/matapelajaran.png';
import raport from '../../assets/img/kurikulum/raport.png';
import ulangan from '../../assets/img/kurikulum/ulangan.png';
import { map } from "lodash";

export default class Kurikulum extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickPengumuman = this.onClickPengumuman.bind(this);
    this.onClickJadwal = this.onClickJadwal.bind(this);
    this.onClickUlangan = this.onClickUlangan.bind(this);
    this.onClickMataPelajaran = this.onClickMataPelajaran.bind(this);
    this.onClickBobotPenilaian = this.onClickBobotPenilaian.bind(this);
    this.onClickRencanaPenilaian = this.onClickRencanaPenilaian.bind(this);
    this.onClickRaport = this.onClickRaport.bind(this);
    this.onClickAnalisa = this.onClickAnalisa.bind(this);
  }

  onClickPengumuman() {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/pengumuman');
  }
  onClickJadwal() {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/jadwal');
  }
  onClickUlangan() {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/ulangan');
  }

  onClickMataPelajaran() {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/mata-pelajaran');
  }

  onClickBobotPenilaian() {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/bobot-penilaian');
  }
  onClickRencanaPenilaian() {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/rencana-penilaian');
  }

  onClickRaport() {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/raport');
  }

  onClickAnalisa() {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/analisa');
  }

  render() {
    const { user } = this.props;
    const { user_group } = user;
    const { permissions } = user_group;
    const permissions_name = [];

    map(permissions, (list, idx) => {
      permissions_name.push(list.name);
    });
    return (
      <div className="finance">
        {permissions_name.indexOf("pengumuman") > -1 == true && (
        <div className="finance__list">
          <button onClick={this.onClickPengumuman}>
            <img src={pengumuman} alt="Pengumuman" />
            <h3>Pengumuman</h3>
          </button>
        </div>
        )}
        {permissions_name.indexOf("jadwal_kelas_guru") > -1 == true && (
        <div className="finance__list">
          <button onClick={this.onClickJadwal}>
            <img src={jadwal} alt="jadwal_kelas_guru" />
            <h3>Jadwal</h3>
          </button>
        </div>
        )}
        {permissions_name.indexOf("pengisian_nilai") > -1 == true && (
        <div className="finance__list">
          <button onClick={this.onClickUlangan}>
            <img src={ulangan} alt="Ulangan" />
            <h3>Ulangan</h3>
          </button>
        </div>
        )}
        {permissions_name.indexOf("kode_mata_pelajaran") > -1 == true && (
        <div className="finance__list">
          <button onClick={this.onClickMataPelajaran}>
            <img src={matapelajaran} alt="Matapelajaran" />
            <h3>Mata Pelajaran</h3>
          </button>
        </div>
        )}
        {/* <div className="finance__list">
          <button onClick={this.onClickBobotPenilaian}>
            <img src={budgeting} alt="BobotPenilaian" />
            <h3>Bobot Penilaian</h3>
          </button>
        </div> */}
        {/* <div className="finance__list">
          <button onClick={this.onClickRencanaPenilaian}>
            <img src={budgeting} alt="RencanaPenilaian" />
            <h3>Rencana Penilaian</h3>
          </button>
        </div> */}
        {permissions_name.indexOf("daftar_nilai_raport") > -1 == true && (
        <div className="finance__list">
          <button onClick={this.onClickRaport}>
            <img src={raport} alt="Raport" />
            <h3>Raport</h3>
          </button>
        </div>
        )}
        {/* <div className="finance__list">
          <button onClick={this.onClickAnalisa}>
            <img src={budgeting} alt="Analisa" />
            <h3>Analisa</h3>
          </button>
        </div> */}

      </div>
    );
  }
}
Kurikulum.propTypes = {
  history: PropTypes.object.isRequired,
};
